<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">حداقل مبلغ هدیه معرف</h5>
        <button
          :disabled="disabled"
          type="button"
          @click="submitChanges"
          class="btn btn-success"
        >
          ثبت تغییرات
        </button>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-4">
            <label for="" class="control-label">حداقل مبلغ هدیه معرف:</label>
            <b-form-input :value="min_first_order | priceinput" @input="value=>{min_first_order = value !== '' ? +value.replace(/\D/g, '') : ''}"
              type="text"/>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import MinFirstOrderLmpl from "@@/core/pages/customerClub/clubSettings/minFirstOrder/MinFirstOrderLmpl.js";
export default {
  extends: MinFirstOrderLmpl,
};
</script>
